import React, { useEffect, useRef } from "react";
import { Card, Button, Tabs } from "antd";
import { useModel, useModelDispatchers } from "../../../models";
import { ProfileTwoTone } from "@ant-design/icons";
import SupplierForm from "./SupplierForm";
import { CM_ACTION_TYPE, ENV } from "../../../utils/constants";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

export default function () {
    const { closeNav } = useModelDispatchers("nav");
    const [{ tabsKey }, { setTabsKey }] = useModel("supplier")
    const formRef = useRef();
    const onSave = () => {
        formRef.current.insert();
    }
    const onReset = () => {
        formRef.current.reset();
    }
    const update = () => {
        formRef.current.update();
    }
    const onClose = () => {
        closeNav();
    }
    useEffect(() => {
        setTabsKey(1)
    }, [])

    const Title = () => {
        return (
            <div style={{ display: "flex" }}>
                <h3 style={{ flex: "1" }}>
                    <ProfileTwoTone />
                    <span className="margin-left-8">供应商明细</span>
                </h3>
                {tabsKey == 1 ?
                    <div style={{ width: "500px", textAlign: "right" }}>
                        <YhAuth resCode={ResourceAuthEnum.DATA_S_ED_SAVE}>
                            <Button type="primary" onClick={update}>保存</Button>
                        </YhAuth>
                        <Button className="margin-left-8" onClick={onReset}>重置</Button>
                        <Button className="margin-left-8" onClick={onClose}>关闭</Button>
                    </div>
                    : ""}
            </div>
        )
    }
    const _onChange = (key) => {
        setTabsKey(key)
    }
    const TabPane = [
        { key: "resizeLimit", name: "调额记录" },
        { key: "recharge", name: "充值记录" },
        { key: "transferAccounts", name: "转账记录" },
    ]
    return (
        <Card
            title={<Title />}
            bordered={true}
            className="margin-top-8"
        >
            <Tabs tabPosition="top"
                onChange={_onChange}
            >
                <Tabs.TabPane tab="基本信息" key="1">
                    <SupplierForm formRef={formRef} actionType={CM_ACTION_TYPE.EDIT} />
                </Tabs.TabPane>
            </Tabs>

        </Card>
    )
};